import React from 'react'

import SyncIcon from '@mui/icons-material/Sync'
import { Button, CircularProgress } from '@mui/material'

interface Props {
  loading: boolean
  refresh: () => any
}

const RefreshButton: React.FC<Props> = ({ loading, refresh }) => {
  return (
    <Button color="primary" size="large" onClick={refresh}>
      {loading ? (
        <CircularProgress
          size={24}
          sx={{
            mr: 1,
            ml: 0.4,
            mb: 0.7,
            mt: 0.7,
          }}
        />
      ) : (
        <SyncIcon fontSize="large" />
      )}
      {'REFRESH'}
    </Button>
  )
}

export default RefreshButton
